"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemToolConfigInputParams = void 0;
const core = __importStar(require("../../core"));
const EndCallToolConfig_1 = require("./EndCallToolConfig");
const LanguageDetectionToolConfig_1 = require("./LanguageDetectionToolConfig");
const PlayDtmfToolConfig_1 = require("./PlayDtmfToolConfig");
const SkipTurnToolConfig_1 = require("./SkipTurnToolConfig");
const TransferToAgentToolConfig_1 = require("./TransferToAgentToolConfig");
const TransferToNumberToolConfigInput_1 = require("./TransferToNumberToolConfigInput");
exports.SystemToolConfigInputParams = core.serialization
    .union(core.serialization.discriminant("systemToolType", "system_tool_type"), {
    end_call: EndCallToolConfig_1.EndCallToolConfig,
    language_detection: LanguageDetectionToolConfig_1.LanguageDetectionToolConfig,
    play_keypad_touch_tone: PlayDtmfToolConfig_1.PlayDtmfToolConfig,
    skip_turn: SkipTurnToolConfig_1.SkipTurnToolConfig,
    transfer_to_agent: TransferToAgentToolConfig_1.TransferToAgentToolConfig,
    transfer_to_number: TransferToNumberToolConfigInput_1.TransferToNumberToolConfigInput,
})
    .transform({
    transform: (value) => value,
    untransform: (value) => value,
});
